// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"pg-service-order-tracking-common":"3f67a59dc4e8b82b8f57","OrderTracking":"ae89480e0f88297ec105","OrderTrackingInformation":"af26cbe9fd2583a5b2dc","OrderStatusInfo":"af8625f72441f5901542"}[chunkId] + ".bundle.js";
};